import { CaretLeft } from '@phosphor-icons/react';

export default CaretLeft;
